module.exports = __webpack_public_path__ + "img/004.af5c6806.jpg";